import { useState } from "react";
import { Link, useNavigate } from "react-router";
import { api, ApiError } from "@/shared/api";
import { s } from "@/shared/strings";
import { Button } from "@/shared/components/ui/button";
import { Input } from "@/shared/components/ui/input";
import { Label } from "@/shared/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/shared/components/ui/card";
import { Logo } from "@/shared/components/Logo";

export function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [sent, setSent] = useState(false);
  const [mode, setMode] = useState<"password" | "magic">("password");
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      if (mode === "magic") {
        await api.magicLink(email);
        setSent(true);
      } else {
        await api.login(email, password);
        nav("/host");
      }
    } catch (ex) {
      setErr(ex instanceof ApiError ? ex.message : "Erro inesperado.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="bg-bg flex min-h-dvh flex-col items-center justify-center px-6 py-10">
      <div className="w-full max-w-sm">
        <Link to="/" className="mb-8 flex justify-center">
          <Logo />
        </Link>
        <Card>
          <CardHeader>
            <CardTitle>{s.login}</CardTitle>
          </CardHeader>
          <CardContent>
            {sent ? (
              <p className="text-16 text-ok">{s.magicLinkSent}</p>
            ) : (
              <form onSubmit={submit} className="flex flex-col gap-4">
                <div className="flex flex-col gap-2">
                  <Label htmlFor="email">{s.email}</Label>
                  <Input
                    id="email"
                    type="email"
                    required
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                {mode === "password" && (
                  <div className="flex flex-col gap-2">
                    <div className="flex items-baseline justify-between">
                      <Label htmlFor="password">{s.password}</Label>
                      <Link
                        to="/redefinir-senha"
                        className="text-14 text-chalk-3 hover:text-amber-fg"
                      >
                        {s.forgotPassword}
                      </Link>
                    </div>
                    <Input
                      id="password"
                      type="password"
                      required
                      autoComplete="current-password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                )}
                {err && <p className="text-14 text-bad font-semibold">{err}</p>}
                <Button type="submit" disabled={busy} className="w-full">
                  {mode === "magic" ? s.loginWithMagicLink : s.login}
                </Button>
                <button
                  type="button"
                  className="text-14 text-chalk-2 hover:text-amber-fg underline-offset-4 hover:underline"
                  onClick={() => setMode(mode === "magic" ? "password" : "magic")}
                >
                  {mode === "magic" ? "Entrar com senha" : s.loginWithMagicLink}
                </button>
              </form>
            )}
          </CardContent>
        </Card>
        <p className="text-14 text-chalk-3 mt-6 text-center">
          Ainda não tem conta?{" "}
          <Link to="/criar-conta" className="text-amber-fg font-semibold hover:underline">
            {s.createAccount}
          </Link>
        </p>
      </div>
    </main>
  );
}
